import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Box, Tooltip } from '@mui/material';

const OverflowTooltipV2 = ({ children, ...props }) => {
    const ref = useRef(null);
    const [isOverflown, setIsOverflown] = useState(false);

    useEffect(() => {
        const compareSize = () => {
            const element = ref.current;
            if (element) {
                setIsOverflown(element.scrollWidth > element.clientWidth);
            }
        };

        compareSize();
        window.addEventListener('resize', compareSize);
        return () => window.removeEventListener('resize', compareSize);
    }, [children]);

    return (
        <Tooltip
            title={isOverflown ? children : ''}
            componentsProps={{
                tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                arrow: { sx: { color: '#272727' } },
            }}
        >
            <Box sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} ref={ref} {...props}>
                {children}
            </Box>
        </Tooltip>
    );
};

OverflowTooltipV2.propTypes = {
    children: PropTypes.any,
};

OverflowTooltipV2.defaultProps = {
    children: '',
};

export default React.memo(OverflowTooltipV2);
